import { Config } from './types/whiteLabel';

const config: {
  [key: string]: Config;
} = {
  'app.heltar.com': {
    name: 'Heltar',
    appName: 'HeltarChat',
    apiUrl: 'https://api.heltar.com',
    heltarBotUrl: 'https://ai-bot-builder.heltar.com',
    hostname: 'app.heltar.com',
    showGoogleLogin: true,
  },
  'app-dev.heltar.com': {
    name: 'Heltar Dev',
    appName: 'HeltarChat Dev',
    apiUrl: 'http://localhost:4000',
    heltarBotUrl: 'http://localhost:3000',
    hostname: 'app-dev.heltar.com',
    showGoogleLogin: true,
  },
  localhost: {
    name: 'Local',
    appName: 'Local App',
    heltarBotUrl: 'http://localhost:3000',
    apiUrl: 'http://localhost:4000',
    // apiUrl: 'http://192.168.1.6:4000',
    // apiUrl: 'https://api-dev.heltar.com',
    // isThreeDotNavbarForMobile: true,
    hostname: 'localhost',
    viewInstallApp: false,
    showGoogleLogin: true,
  },
  'chat.convoset.com': {
    name: 'Convoset',
    appName: 'Convoset',
    apiUrl: 'https://api.heltar.com',
    hostname: 'chat.convoset.com',
    navbarOptionsShow: {
      6: false,
      9: false,
    },
    inSettingsOptionsShow: {
      29: { isShowOption: false },
    },
  },
  'waba.growwsaas.com': {
    name: 'V-Connect',
    appName: 'V-Connect',
    apiUrl: 'https://wapi.growwsaas.com',
    heltarBotUrl: 'https://ai-bot-builder.heltar.com',
    hostname: 'waba.growwsaas.com',
    navbarOptionsShow: {
      6: false, // Hide "Convobot" from navbar
      9: false, // Hide "Refer & Earn" from navbar
    },
    inSettingsOptionsShow: {
      29: { isShowOption: false }, // Hide "Refer & Earn" from settings
    },
    logoHeight: 60,
    logoWidth: 60,
  },
  'waba.msgadvert.com': {
    name: 'MsgAdvert',
    appName: 'MsgAdvert',
    apiUrl: 'https://api.heltar.com',
    heltarBotUrl: 'https://ai-bot-builder.heltar.com',
    hostname: 'waba.msgadvert.com',
    navbarOptionsShow: {
      6: false, // Hide "Convobot" from navbar
      9: false, // Hide "Refer & Earn" from navbar
    },
    inSettingsOptionsShow: {
      29: { isShowOption: false }, // Hide "Refer & Earn" from settings
    },
    logoHeight: 60,
    logoWidth: 180,
    showAppNameWithLogo: false,
  },
  'waba.routemobile.online': {
    name: 'Route Mobile',
    appName: 'Route Mobile',
    apiUrl: 'https://wabaapi.routemobile.online',
    heltarBotUrl: 'https://ai-bot-builder.heltar.com',
    hostname: 'waba.routemobile.online',
    navbarOptionsShow: {
      6: false, // Hide "Convobot" from navbar
      9: false, // Hide "Refer & Earn" from navbar
    },
    inSettingsOptionsShow: {
      29: { isShowOption: false }, // Hide "Refer & Earn" from settings
    },
    logoHeight: 40,
    logoWidth: 180,
    showAppNameWithLogo: false,
  },
  'waba.telenama.in': {
    name: 'Telenama',
    appName: 'Telenama',
    apiUrl: 'https://wabaapi.telenama.in',
    heltarBotUrl: 'https://ai-bot-builder.heltar.com',
    hostname: 'waba.telenama.in',
    navbarOptionsShow: {
      6: false, // Hide "Convobot" from navbar
      9: false, // Hide "Refer & Earn" from navbar
    },
    inSettingsOptionsShow: {
      29: { isShowOption: false }, // Hide "Refer & Earn" from settings
    },
    logoHeight: 75,
    logoWidth: 100,
    showAppNameWithLogo: false,
  },
  'whatsapp.revainfosolution.com': {
    name: 'Reva Info Solution',
    appName: 'Reva Info Solution',
    apiUrl: 'https://api.heltar.com',
    heltarBotUrl: 'https://ai-bot-builder.heltar.com',
    hostname: 'whatsapp.revainfosolution.com',
    navbarOptionsShow: {
      6: false, // Hide "Convobot" from navbar
      9: false, // Hide "Refer & Earn" from navbar
    },
    inSettingsOptionsShow: {
      29: { isShowOption: false }, // Hide "Refer & Earn" from settings
    },
    logoHeight: 45,
  },
  'app.wappinbox.com': {
    name: 'Wappinbox',
    appName: 'Wappinbox',
    apiUrl: 'https://api.heltar.com',
    heltarBotUrl: 'https://ai-bot-builder.heltar.com',
    hostname: 'app.wappinbox.com',
    navbarOptionsShow: {
      6: false, // Hide "Convobot" from navbar
      9: false, // Hide "Refer & Earn" from navbar
    },
    inSettingsOptionsShow: {
      29: { isShowOption: false }, // Hide "Refer & Earn" from settings
    },
    logoHeight: 35,
    logoWidth: 130,
    showAppNameWithLogo: false,
  },
  'app.botrixai.com': {
    name: 'BotrixAI',
    appName: 'BotrixAI',
    apiUrl: 'https://newapi.botrixai.com',
    heltarBotUrl: 'https://ai-bot-builder.heltar.com',
    hostname: 'app.botrixai.com',
    navbarOptionsShow: {
      6: false, // Hide "Convobot" from navbar
      9: false, // Hide "Refer & Earn" from navbar
    },
    inSettingsOptionsShow: {
      29: { isShowOption: false }, // Hide "Refer & Earn" from settings
    },
    showAppNameWithLogo: true,
  },
  'waba-agents.ailifebot.com': {
    name: 'AiLifeBot',
    appName: 'Ai LifeBot',
    apiUrl: 'https://waba-agentsapi.ailifebot.com',
    heltarBotUrl: 'https://ai-bot-builder.heltar.com',
    hostname: 'waba-agents.ailifebot.com',
    navbarOptionsShow: {
      6: false, // Hide "Convobot" from navbar
      9: false, // Hide "Refer & Earn" from navbar
    },
    inSettingsOptionsShow: {
      29: { isShowOption: false }, // Hide "Refer & Earn" from settings
    },
    logoWidth: 120,
    logoHeight: 40,
    showAppNameWithLogo: false,
  },
  'ai.masivapp.com': {
    name: 'Masiv',
    appName: 'Masiv',
    apiUrl: 'https://api.heltar.com',
    heltarBotUrl: 'https://ai-bot-builder.heltar.com',
    hostname: 'ai.masivapp.com',
    navbarOptionsShow: {
      6: false, // Hide "Convobot" from navbar
      9: false, // Hide "Refer & Earn" from navbar
    },
    inSettingsOptionsShow: {
      /* Signup tabs default to VISIBLE (WhatsappDetailRegister reads
         `settingsOptions?.[tab.configKey] ?? true`), so every other BSP has to
         be opted out by name — Masiv's own customers must not be shown tabs
         labelled Tata / Kaleyra / Route Mobile / V Connect. */
      1: {
        isShowOption: true,
        isShowMasivSignUp: true,
        isShowEmbeddedSignUp: false,
        isShowFirstConnectSignUp: false,
        isShowTataSignUp: false,
        isShowKaleyraSignUp: false,
        isShowValueFirstSignUp: false,
        isShowVConnectSignUp: false,
        isShowRouteMobileSignUp: false,
        isShowOnextelSignUp: false,
      },
      29: { isShowOption: false }, // Hide "Refer & Earn" from settings
    },
    // Matches the 788x188 horizontal wordmark shipped as icon-192x192.png —
    // AvatarImage stretches to the box, so the ratio has to be kept.
    logoHeight: 50,
    logoWidth: 220,
    showAppNameWithLogo: false,
  },
  'partners.heltar.com': {
    name: 'Partner',
    appName: 'Partner Dashboard',
    apiUrl: 'https://api.heltar.com',
    // apiUrl: 'http://localhost:4000',
    hostname: 'partners.heltar.com',
    isPartnerDashboard: true,
  },
};

/**
 * Get domain config
 * - APK builds: Uses VITE_APP_DOMAIN env variable (set by android/build.mjs)
 * - Web: Falls back to window.location.hostname
 *
 * Resolution order for hosts NOT in the white-label map above:
 *
 * 1. window.__HELTAR_CONFIG__ — set by /runtime-config.js. On-prem images
 *    generate that file from env vars at container start, so ONE generic
 *    build serves any customer domain; changing URLs is a container
 *    restart, not a rebuild. (On Heltar SaaS the file is a committed
 *    no-op, so this branch never fires there.)
 * 2. VITE_API_URL (+ VITE_APP_NAME / VITE_HELTARBOT_URL) baked at build
 *    time — kept for bespoke per-customer builds.
 * 3. The localhost dev shim.
 */
/* On-prem / self-hosted deployments must expose ONLY the Custom connect
   flow. Every BSP signup tab launches Meta embedded signup with a
   Heltar/RML solution id baked into the bundle — a completed popup mints a
   WABA billed to the RML credit line with no record in this install's
   platform DB. WhatsappDetailRegister defaults every tab to visible
   (`?? true`), so each one has to be opted out by name (same convention as
   the white-label entries above). */
const onPremSettingsOptions: Config['inSettingsOptionsShow'] = {
  1: {
    isShowOption: true,
    isShowCustomSignUp: true,
    isShowEmbeddedSignUp: false,
    isShowFirstConnectSignUp: false,
    isShowTataSignUp: false,
    isShowKaleyraSignUp: false,
    isShowValueFirstSignUp: false,
    isShowVConnectSignUp: false,
    isShowRouteMobileSignUp: false,
    isShowMasivSignUp: false,
    isShowOnextelSignUp: false,
  },
};

/** Each known domain's API, for index.html to connect to before the app file arrives. */
export const apiUrlByHost: Record<string, string> = Object.fromEntries(
  Object.entries(config).map(([host, { apiUrl }]) => [host, apiUrl]),
);

export const getDomainConfig = (): Config => {
  const domain = import.meta.env.VITE_APP_DOMAIN as string | undefined;
  const host = domain || window.location.hostname;

  const known = config[host];
  if (known) return known;

  const runtime =
    typeof window !== 'undefined' ? window.__HELTAR_CONFIG__ : null;
  if (runtime?.apiUrl) {
    const runtimeAppName = runtime.appName ?? 'HeltarChat';
    return {
      name: runtimeAppName,
      appName: runtimeAppName,
      apiUrl: runtime.apiUrl,
      heltarBotUrl: runtime.heltarBotUrl,
      hostname: host,
      assetsDir: runtime.assetsDir ?? 'default',
      showGoogleLogin: runtime.showGoogleLogin ?? true,
      // The Convobot builder is SaaS-hosted and not part of the on-prem
      // offering — hide its nav entry (same convention as white-labels).
      // isHeltarBotEnabled defaults to true for new businesses, so without
      // this the entry renders and iframes localhost:3000.
      navbarOptionsShow: { 6: false },
      inSettingsOptionsShow: onPremSettingsOptions,
    };
  }

  const envApiUrl = import.meta.env.VITE_API_URL as string | undefined;
  if (envApiUrl) {
    const envAppName =
      (import.meta.env.VITE_APP_NAME as string | undefined) ?? 'HeltarChat';
    return {
      name: envAppName,
      appName: envAppName,
      apiUrl: envApiUrl,
      heltarBotUrl: import.meta.env.VITE_HELTARBOT_URL as string | undefined,
      hostname: host,
      assetsDir: 'default',
      showGoogleLogin: true,
      // Same rationale as the runtime-config branch above.
      navbarOptionsShow: { 6: false },
      inSettingsOptionsShow: onPremSettingsOptions,
    };
  }

  return config.localhost;
};
